import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=2c747a09"
import script from "./ReportDetails.vue?vue&type=script&lang=ts"
export * from "./ReportDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReportDetails.vue?vue&type=style&index=0&id=2c747a09&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports